<template>
    <div :class="[classIcon[type][level], { disabled: isDisabled, 'border border-dark border-current': isCurrent }, 'position-relative']"
        @click="addActive($el)">
        <span class="material-symbols-outlined fill-current">
            <span v-if="level >= 4">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780Zm-455-80h311q-10-20-55.5-35T480-370q-55 0-100.5 15T325-320ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Zm0-80q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm1 240Zm-1-280Z"/></svg>            </span>
            <span v-else-if="level <= 1">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z"/></svg>
            </span>
            <span v-else>
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z"/></svg>
            </span>
        </span>
            <span class="title text-xs text-opacity-80 font-semibold">{{ title }}</span>
            <span v-if="!isBased"
                    class="position-absolute top-0 start-100 translate-middle badge border border-light rounded-circle bg-warning p-2">
                    <span class="visually-hidden"></span>
            </span>
    </div>
</template>
  
<script>
export default {
    props: {
        level: {
            type: Number,
            required: true
        },
        type: {
            type: Number,
            required: true
        },
        title: {
            type: String,
            default: '',
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        isCurrent: {
            type: Boolean,
            default: false,
        },
        reRender: {
            type: Number,
            required: false
        },
        isBased: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        classIcon() {
            return [
                [
                    'btn btn-dark gap-2 mb-1',
                    'btn btn-info badge-outline bg-white gap-2 mb-1',
                    'btn btn-info gap-2 mb-1',
                    'btn btn-success gap-2 mb-1',
                    'btn btn-warning gap-2 mb-1',
                    'btn btn-danger gap-2 mb-1'
                ],
                [
                    'badge rounded p-3 bg-base-100 badge-outline disabled badge-neautral gap-2 mb-1 congestion-badge',
                    'badge rounded p-3 bg-base-100 badge-outline disabled badge-info badge-outline bg-white gap-2 mb-1 congestion-badge',
                    'badge rounded p-3 bg-base-100 badge-outline disabled badge-info gap-2 mb-1 congestion-badge',
                    'badge rounded p-3 bg-base-100 badge-outline disabled badge-success gap-2 mb-1 congestion-badge',
                    'badge rounded p-3 bg-base-100 badge-outline disabled badge-warning gap-2 mb-1 congestion-badge',
                    'badge rounded p-3 bg-base-100 badge-outline disabled badge-error gap-2 mb-1 congestion-badge'
                ]
            ];
        }
    },
    methods: {
        addActive(el) {
            this.removeActive();
            el.classList.add('border', 'border-secondary', 'border-active');
        },
        removeActive() {
            let el = document.querySelectorAll('.border-active');
            for (let i = 0; i < el.length; i++) {
                el[i].classList.remove('border', 'border-secondary','border-active');
            }
        }
    }
};
</script>
  
<style>
.disabled {
    cursor: not-allowed;
    pointer-events: none;
}

.border-current {
    border-width: 3px !important;
    border-color: #0d6efd !important;
}
.border-active{
    border-width: 3px !important;
}
</style>